<template>
	<div 
		class="terms-and-conditions-content"
		:class="{ 'is-danger': !termsAccepted, 'is-success': termsAccepted }"
	>
		<p>Members of BTS must adhere to the following <strong>Code of Conduct</strong> and ensure they have read and accept the <a href="https://bts.org.uk/membership/society-rules/" target="_blank" rel="noopener noreferrer">Society Rules</a> found on our website.</p><br />
		<p><i>As a member of the British Transplantation Society, I commit to professionalism, integrity, and respect. I will maintain competence, uphold ethical standards, respect confidentiality, and prioritise patient welfare. I will treat all members equally, avoid discrimination, and foster collaboration. I accept accountability for my actions and will report misconduct. I will pursue ongoing professional development, declare conflicts of interest, and avoid exploitation. I will help create a safe, inclusive, harassment-free environment and support the Society’s mission to advance transplantation practice and research. I understand my conduct reflects on the Society and I agree to commit to these principles.</i></p>
	</div>
</template>

<script>
export default {
	name: 'TermsAndConditions',

	props: ['termsAccepted'],
};
</script>

<style scoped>
.terms-and-conditions-content {
	padding: 2rem 0;
}

.terms-and-conditions-content p {
	font-size: 1.1rem;
	line-height: 1.6;
}

.terms-and-conditions-content a {
	color: #3273dc;
	text-decoration: underline;
	font-weight: 500;
}

.terms-and-conditions-content a:hover {
	color: #2366d1;
}
</style>
